import { clearEmpty } from '../../helpers/objectHelper'

import { FAIL, FILE_FAIL, FILE_UPLOAD, START, SUCCESS } from '../../constants'


export default (store) => (next) => (action) => {
	const {
		callPOST, type, token, payload, queryData, fileData, thenAction, thenError, externalService = false
	} = action
	if (!callPOST) return next(action)

	next({
		...action,
		type: type + START
	})

	const xhr = new XMLHttpRequest()

	xhr.open('POST', callPOST, true)
	if (token) xhr.setRequestHeader('Authorization', 'Bearer ' + token)

	let body = ''
	if (queryData) {
		body = JSON.stringify(clearEmpty(queryData))
		xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8')
	}
	if (fileData) {
		body = new FormData()
		body.append('file', fileData.file, fileData.file.name);
		body.append('type_id', JSON.stringify(Number(fileData.type_id)))
		if (fileData.model_id) body.append('model_id', JSON.stringify(Number(fileData.model_id)))
	}

	xhr.upload.onprogress = function (event) {
		const { total, loaded } = event
		next({
			...action,
			type: type + FILE_UPLOAD,
			upload: Math.floor(loaded * 100 / total)
		})
	}

	xhr.upload.onload = function () {
		// alert(`Данные успешно отправлены.`);
	}

	xhr.upload.onerror = function () {
		next({
			...action,
			type: type + FILE_FAIL,
			error: `Произошла ошибка во время отправки: ${xhr.status}`
		})
	}

	xhr.send(body)

	xhr.onreadystatechange = function () { // (3)
		if (xhr.readyState != 4) return

		if (xhr.status != 200) {
			const responseText = JSON.parse(xhr.responseText)
			next({
				...action,
				type: type + FAIL,
				response: { error: xhr.status + ': ' + xhr.statusText },
				error: xhr.status + ': ' + xhr.statusText,
				messages: responseText.messages,
				errorResponse: responseText?.response ? responseText.response : null
			})

		} else {

			const responseText = JSON.parse(xhr.responseText)
			let messages = []
			if (Array.isArray(responseText.messages)) {
				messages = responseText.messages.map((elem) => elem.message).join('|')
			}
			if (responseText.status == 100) {
				next({
					...action,
					type: type + FAIL,
					response: { error: messages, messages: responseText.messages },
					error: messages,
					errorResponse: responseText?.response ? responseText.response : null
				})
				if (thenError) {
					store.dispatch(thenError.func(...thenError.args, responseText))
				}
			} else {
				const response = externalService ? responseText : responseText.status === 0
					? {
						status: 'success',
						success: true,
						message: messages,
						messages: responseText.messages,
						data: responseText.response
					}
					: {
						status: 'fail',
						success: false,
						messages: responseText.messages,
						message: messages

					}

				next({
					...action,
					type: type + SUCCESS,
					response
				})

				if (thenAction) {
					store.dispatch(thenAction.func(...thenAction.args))
				}
			}

			// return JSON.parse(xhr.responseText).response
		}

	}

}
